<template>
    <div class="notification-wrapper-class">
        <div class="row m0">
            <template v-if="Type == 'Notification'">
                <div class="col-md-12 notification-main">
                    <div class="col-md-1 text-center" style="padding-top: 5px;padding-left: 3px;">
                        <img class="imgcls" :src='`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/notification/ic_notification.svg`'>
                    </div>
                    <div class="col-md-8 pR0 alert-desc" @click="onAlertClick">
                        <p class="title_text" v-html="description"></p>
                        <div class="alert-time">
                            <p><i aria-hidden="true" class="fa fa-clock-o"></i> {{AlertTime}} </p>
                        </div>
                    </div>
                    <div class="col-md-3 text-center"  style="margin: 6px 0;padding: 0;">
                        <div class="right_div">
                            <a style="color: #4A90E2"  @click="onMarkAsRead" >Mark as Read</a>
                            <span class="cross-img-span" > <img  @click="closeNotification" class="cross-img" :src='`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_close.svg`'></span>
                        </div>
                    </div>
                </div>

            </template>
            <template v-if="Type == 'Danger'">
                <div class="col-md-12 notification-main">
                    <div class="col-md-1 text-center" style="padding-top: 5px;padding-left: 3px;">
                        <img class="imgcls" :src='`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/notification/ic_highalert.svg`'>
                    </div>
                    <div class="col-md-8 pR0 alert-desc"  @click="onAlertClick">
                        <p class="title_text">{{description}}</p>
                        <div class="alert-time">
                            <p><i aria-hidden="true" class="fa fa-clock-o"></i> {{AlertTime}} </p>
                        </div>
                    </div>
                    <div class="col-md-3 text-center">
                        <div class="right_div">
                            <div class="dropdown show" style="display: inline-block !important;">
                               <ob-popover @show="showPopover" class="popover-class" :visibleArrow="false" trigger="click" :options="{placement: 'top'}" ref="popover" >
                                    <div :id="popoverId" class="popper" >
                                        <a class="snooze-options" @click="addSnoozeTime(1)">Remind me in 1 hour</a>
                                        <a class="snooze-options"  @click="addSnoozeTime(3)">Remind me in 3 hour</a>
                                        <a class="snooze-options"  @click="addSnoozeTime(8)">Remind me in 8 hour</a>
                                    </div>
                                    <a slot="reference">
                                        <p style="color:#337ab7;font-weight: 700;font-size: 13px;display: inline-block ">Snooze</p>
                                          <i class="fa fa-chevron-down" v-if="!snoozeSelected"  aria-hidden="true"></i>
                                          <i class="fa fa-chevron-up" v-else aria-hidden="true"></i>
                                    </a>
                                </ob-popover>
                          </div>
                              <span class="cross-img-span" > <img  @click="closeNotification" class="cross-img" :src='`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_close.svg`'></span>
                        </div>
                    </div>
                </div>
            </template>
             <template v-if="Type == 'Warning'">
                <div class="col-md-12 notification-main">
                    <div class="col-md-1 text-center" style="padding-top: 5px;padding-left: 3px;">
                        <img class="imgcls" :src='`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/notification/ic_mediumalert.svg`'>
                    </div>
                    <div class="col-md-8 pR0 alert-desc" @click="onAlertClick">
                        <p class="title_text">{{description}}</p>
                        <div class="alert-time">
                            <p><i aria-hidden="true" class="fa fa-clock-o"></i> {{AlertTime}} </p>
                        </div>
                    </div>
                    <div class="col-md-3 text-center">
                        <div class="right_div">
                            <div class="dropdown show" style="display: inline-block !important;">
                               <ob-popover @hide="hidePopover"  @show="showPopover" class="popover-class" :visibleArrow="false"  trigger="click" :options="{placement: 'top'}" ref="popover">
                                    <div :id="popoverId" class="popper">
                                        <a class="snooze-options" @click="addSnoozeTime(1)">Remind me in 1 hour</a>
                                        <a class="snooze-options"  @click="addSnoozeTime(3)">Remind me in 3 hour</a>
                                        <a class="snooze-options"  @click="addSnoozeTime(8)">Remind me in 8 hour</a>
                                    </div>
                                    <a  slot="reference">
                                        <p style="color:#337ab7;font-weight: 700;font-size: 13px;display: inline-block ">Snooze</p>
                                           <i class="fa fa-chevron-down"  v-if="!snoozeSelected"  aria-hidden="true"></i>
                                          <i class="fa fa-chevron-up"  v-else  aria-hidden="true"></i>
                                    </a>
                                </ob-popover>
                          </div>
                             <span class="cross-img-span" > <img  @click="closeNotification" class="cross-img" :src='`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_close.svg`'></span>
                        </div>
                    </div>
                </div>
            </template>
             <template v-if="Type=='MoreCount'">
                <div class="col-md-12 notification-main">
                    <div class="col-md-1 text-center" style="padding-top: 5px;padding-left: 3px;">
                        <img class="imgcls" :src='`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/notification/ic_highalert.svg`'>
                    </div>
                    <div class="col-md-8 pR0 alert-desc"  @click="goToViewAllAlerts">
                        <p class="noty-number-style">+{{alertCount}}</p>
                    </div>
                    <div class="col-md-3 text-center">
                        <div class="right_div">
                               <span class="cross-img-span" > <img  @click="closeNotification" class="cross-img" :src='`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_close.svg`'></span>
                        </div>
                    </div>
                </div>
            </template>
            </div>
        </div>
</template>
<script>
export default {
    props: ["props"],
    data() {
        return {
           AlertTime:'',
           CreatedDateTime:moment(),
           snoozeSelected:false
        }
    },
    watch: {

    },
    components: {

    },
    computed: {
        EmployeeId()
        {
           return this.loggedInUserObj.empId ? this.loggedInUserObj.empId : '';
        },
        notificationData()
        {
            return this.props.item.data
        },
        getPopover()
        {
            return document.getElementById(`${this.popoverId}`)
        },
        popoverId() {
            return __.uniqueId(`${this.id}`+'popover')
        },
        Type()
        {
            return this.notificationData ? this.notificationData.Type : ''
        },
        description()
        {
            return this.notificationData ? this.notificationData.Description : ''
        },
        id()
        {
            return this.notificationData ? this.notificationData.Id : ''
        },
        consultantId()
        {
           return this.notificationData ? this.notificationData.ConsultantId : ''
        },
        alertCount()
        {
            return this.notificationData ? this.notificationData.count : ''
        },
        redirectionTab()
        {
           return this.notificationData ? this.notificationData.Redirection : ''
        }
    },
    created() {
        this.getAlertDate()
        var i = 0 ;
        let interval = setInterval(() => { // to close notification after 25 secs
                var poppor = document.getElementById(`${this.popoverId}`) ;
                if(poppor == null || (poppor != null && poppor.clientWidth == 0))
                {
                    this.closeNotification()
                    clearInterval(interval);
                }else{
                       i = 500;
                       this.getAlertDate()
                }
        }, 20000 + i);
    },
    methods: {
        showPopover()
        {
           this.snoozeSelected = true
        },
        hidePopover()
        {
            this.snoozeSelected = false
        },
        goToViewAllAlerts()
        {
            this.$router.push({name: 'view-all-alerts'})
        },
        getAlertDate()
        {
           this.AlertTime = moment(this.CreatedDateTime).fromNow();
        },
        closeNotification()
        {
            this.props.close();
        },
        addSnoozeTime(time)
        {
            var cDate =  moment().format()
            var obj = {
               Id : this.id,
               SnoozeInterval : time,
               SnoozeDateTime :moment(cDate).add(time, 'seconds'),
               data:this.notificationData,
               EmployeeId: this.EmployeeId,
               HrId:''
             };
            ajax.post(`Compliance/AddSnooze`,obj, (res) => {
                if(res.data.State == true){

                }
            });
             this.closeNotification()
        },
        onMarkAsRead()
        {
            var notificationId = this.id
            if(this.Type == "Notification")
            {
                ajax.post(`/Notifications/MarkNotificationAsRead?notificationId=${notificationId}`,{},res => {
                    if(res.data.State == true){

                    }
                })
             }else{
                ajax.put(`/Compliance/AlertMarkedasReadOrUnread?alertId=${notificationId}`, {}, ( res ) => {
                    if(res.data.State == true){

                    }
                });
             }
             this.closeNotification();
        },
         onAlertClick(){

            this.onMarkAsRead()

            let url = "";
             var hireType = data.HireType != null ? data.HireType : "W2";

           // if(this.consultantId != null && this.consultantId != '')
            {
                if(this.redirectionTab == "Form I-983" || this.redirectionTab == "FormI983"){
                    url = `/employee/form-i983`
                }
                else if(this.redirectionTab == "Leave Settings"){
                url = `/app/admin-settings`
                }
                else if(this.redirectionTab == "Timesheets" || this.redirectionTab == "Leave" || this.redirectionTab == "TimeSheets"){
                   var data = this.notificationData;

                   if(data.Description.includes("rejected"))
                   {
                            if(data.EmployeeId == this.loggedInUserObj.empId)
                            {
                            url = `/evaluation`
                            }
                            else{
                            url = `/ReportingEmployees/employee-evaluation-trainee?EmployeeId=${data.EmployeeId}`
                            }

                   }
                   else if(data.AlertClassification == "TimesheetPending"){
                        if(data.EmployeeId == this.loggedInUserObj.empId){
                          var str = data.Description;
                          var sId = data.SourceId;
                          var startDate = str.substring(31, 41);
                          var endDate = str.substring(45, 55);
                          var projectId = sId.replace(data.EmployeeId,"").replace(moment(startDate).format('YYYYMMDD')+moment(endDate).format('YYYYMMDD'),"")
                          url = `/employee-addtimesheets?startDate=${startDate}&endDate=${endDate}&project=${projectId}`
                        }
                      }else{
                        if(data.EmployeeId == this.loggedInUserObj.empId){
                          url = `/my-timesheets`
                        }else{
                          url = `/employer-timesheets?calenderDate=${data.FromDate != null ? data.FromDate : ''}&searchText=${data.EmployeeEmail != null ? data.EmployeeEmail : ''}&Id=${this.notificationData.SourceId}`;
                        }
                      }
                }
                else if(this.redirectionTab == "H1B") {
                    if(hireType == "C2C" || hireType == "1099")
                    {
                    url = `/employee`
                    }
                    else
                    {
                    url = `/employee/h1b`
                    }
                }
                else if(this.redirectionTab == "FormI9") {
                    url = `/employee/i9`
                }
                else if(this.redirectionTab == "EAD"){
                    if(hireType == "C2C" || hireType == "1099")
                    {
                    url = `/employee`
                    }
                    else
                    {
                    url = `/employee/ead`
                    }
                }
                else if(this.redirectionTab == "Projects"){
                    url = `/employee/projects`
                }
                else if(this.redirectionTab == "PersonnelFile"){
                     url = `/employee/`
                }
            }
            if(url != "") {
                window.open(url, "_blank")
            }
        },
    }
}
</script>
 <style lang="scss" scoped>
    .popper{
        background: #1f2023;
        color: #ffffff;
        width: 161px !important;
        border: none;
        top: -22px !important;
        -webkit-box-shadow: 0px 4px 12px 0px rgba(141,146,150,0.5);
        -moz-box-shadow: 0px 4px 12px 0px rgba(141,146,150,0.5);
        box-shadow: 0px 4px 12px 0px rgba(141,146,150,0.5);

       .snooze-options{
        display: block;
        color: #ffff;
        font-weight: 600;
        font-size: 13px;
        padding: 1px 0 5px 0px;
        }
        .snooze-options:hover{
            color: #337ab7 !important;
        }
    }
    .notification-wrapper-class{
        margin: 0px 0px 5px 0px;
        .dropdown-item{
            display: block;
        }
        .notification-main {
            background-color:#1f2023;
            border-radius: 5px;
            color: white;
            padding: 15px;

            -webkit-box-shadow: 0px 4px 12px 0px rgba(141,146,150,0.5);
            -moz-box-shadow: 0px 4px 12px 0px rgba(141,146,150,0.5);
            box-shadow: 0px 4px 12px 0px rgba(141,146,150,0.5);
        }
        .noty-number-style{
            font-size: 25px;
            font-weight: 800;
            color: #ffff;
        }
        .alert-time i {
            font-size: 13px;
            color: #BABBBD !important;
            padding-right: 5px;
        }
        .alert-time p {
            color: #BABBBD !important;
            padding-right: 5px;
            font-weight: 400;
        }
        .imgcls {
            width: 30px;
            border-radius: 50%;
            margin-left: 10px;
        }
        .cross-img{
            width: 15px;
            border-radius: 50%;
            margin-left: 2px;
            margin-right: 2px;
            display: inline-block !important;
        }
         .cross-img-span{
           border-radius: 5px;
           padding: 2px 1px 2px 2px;
           cursor: pointer !important;
        }
        .cross-img-span:hover{
            background-color: #f6f7f8;
        }
        .title_text {
            word-break: break-word;
            margin-bottom: 8px;
            color: white ;
            cursor: pointer !important;
        }
        .right_div {
            padding-top: 9px;
            font-weight: 600;
            float: right;
        }
        .custom-popover-class{
            background-color: blue;
        }
    }

    .alert-desc :hover{
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Notification/CustomNotification.vue